<mat-chip-row
  [class.readonly]="readonly || !menuData"
  [class.non-removable]="!removable"
  [removable]="removable"
  [matMenuTriggerFor]="menuData ? (menu ?? null) : null"
  [matMenuTriggerData]="menuData ?? null"
  [style.--mat-chip-outline-color]="color"
>
  <ng-content></ng-content>
  @if (removable) {
    <button matChipRemove (click)="$event.stopPropagation(); remove.emit()" aria-label="Remove">
      <mat-icon>cancel</mat-icon>
    </button>
  }
</mat-chip-row>
